import {
  categories_tab,
  menus_tab,
  modifier_groups_tab,
  modifiers_tab,
  products_tab,
} from '../../../../../../views/menu/smart-pricing';
import { SMART_PRICING_RESOURCE_TYPE } from '../../../../../../services/exports/Constants';

export default {
  title: 'Prezzi intelligenti',
  master_title: 'Modalità marchio - Prezzi smart',
  sections: {
    how_it_works: {
      title: 'Come funziona',
      description:
        "I prezzi intelligenti consentono di controllare i prezzi in base al metodo d'ordine del cliente. Coprono diversi scenari: riduzione del prezzo per l'asporto, aumento per la consegna, sconti stagionali, ecc. Puoi creare regole su più livelli (Globale, Menu, Categoria, Prodotto, Gruppo modificatori, Modificatore). I livelli funzionano come un albero: il livello superiore influenza quelli inferiori, ma le regole ai livelli inferiori hanno priorità maggiore (es. uno sconto asporto del 5% su una categoria specifica sovrascrive lo sconto globale del 15% per i suoi prodotti).",
    },
  },
  tabs: {
    [SMART_PRICING_RESOURCE_TYPE.company]: 'Regole globali',
    [SMART_PRICING_RESOURCE_TYPE.franchise]: 'Regole globali',
    [menus_tab]: 'Regole menu',
    [categories_tab]: 'Regole categoria',
    [products_tab]: 'Regole prodotto',
    [modifier_groups_tab]: 'Regole gruppo modificatori',
    [modifiers_tab]: 'Regole modificatore',
  },
  fields: {
    name: 'Nome',
    order_methods: "Metodi d'ordine",
    modifier: 'Modificatore',
    image: 'Immagine',
    actions: 'Azioni',
  },
  labels: {
    absolute: 'Assoluto',
  },
  buttons: {
    add_rule: 'Aggiungi regola',
    edit: 'Modifica',
    delete: 'Elimina ({{count}})',
    images: 'Gestisci immagine',
  },
  popups: {
    delete_rule: {
      title: 'Sicuro di eliminare?',
    },
  },
  toasts: {
    failed_to_load_data: 'Caricamento dati fallito',
    failed_to_delete: 'Eliminazione regole fallita',
    deleted_successfully: 'Regole eliminate con successo',
  },
};
